import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const SubTabsContainer = styled.div`
  display: flex;
  border-bottom: 2px solid #e5e5e5;
  margin-bottom: 12px;
  position: relative;
`;

export const SubTab = styled.button<{ active?: boolean }>`
  background: none;
  border: none;
  outline: none;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  color: ${({ active }) => (active ? colors.text['primary-base'] : colors.text['sub-500'])};
  cursor: pointer;
  transition: 0.2s;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -3px;
    left: 0;
    width: 100%;
    height: 4px;
    background-color: ${({ active }) => (active ? colors.text['primary-base'] : 'transparent')};
    transition: background-color 0.2s;
  }

  &:hover {
    color: ${colors.text['primary-base']};
  }
`;
